import { CreateDriverGroupDto, DriverGroupDto } from '@cargovibe/shared-types';

interface SubmitCreateDriverGroupParams {
  name: string;
  emptyNameMessage: string;
  createDriverGroup: (
    data: CreateDriverGroupDto,
    options: { onSuccess: (group: DriverGroupDto) => void }
  ) => void;
  setName: (name: string) => void;
  setValidationError: (message: string) => void;
  onCreated: (group: DriverGroupDto) => void;
}

export function submitCreateDriverGroup({
  name,
  emptyNameMessage,
  createDriverGroup,
  setName,
  setValidationError,
  onCreated,
}: SubmitCreateDriverGroupParams): void {
  const trimmedName: string = name.trim();
  if (!trimmedName) {
    setValidationError(emptyNameMessage);
    return;
  }

  createDriverGroup(
    { name: trimmedName },
    {
      onSuccess: (group: DriverGroupDto): void => {
        setName('');
        onCreated(group);
      },
    }
  );
}
